import AdminServices from './AdminServices';

const BACKUP_KEY = 'admin_impersonate_backup';

export default {
  isImpersonating() {
    try {
      const data = localStorage.getItem(BACKUP_KEY);
      return Boolean(data);
    } catch (e) {
      return false;
    }
  },

  getBackupSession() {
    try {
      const data = localStorage.getItem(BACKUP_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  },

  async startImpersonate(store, targetUserId) {
    if (!targetUserId) throw new Error('ID người dùng không hợp lệ');

    const currentAdminUser = store.state.user;
    const currentAdminToken = store.state.token || (currentAdminUser && currentAdminUser.token);
    if (!currentAdminUser || currentAdminUser.username !== 'admin') {
      throw new Error('Chỉ có Admin mới có quyền chuyển tài khoản');
    }

    const backup = {
      user: currentAdminUser,
      token: currentAdminToken,
      switchedAt: new Date().toISOString()
    };

    const res = await AdminServices.impersonate(targetUserId);
    if (res.status === 200 && res.data && res.data.userData) {
      const userData = res.data.userData;
      if (!userData.token) {
        userData.token = res.data.token;
      }
      localStorage.setItem(BACKUP_KEY, JSON.stringify(backup));
      if (typeof document !== 'undefined') {
        document.body.classList.add('is-impersonating-active');
      }
      await store.dispatch('setUser', userData);
      return { success: true, user: userData };
    } else {
      const msg = res && res.data && res.data.message ? res.data.message : 'Không thể chuyển tài khoản';
      throw new Error(msg);
    }
  },

  async revertImpersonate(store) {
    const backup = this.getBackupSession();
    localStorage.removeItem(BACKUP_KEY);
    if (typeof document !== 'undefined') {
      document.body.classList.remove('is-impersonating-active');
    }

    if (!backup || !backup.user) {
      throw new Error('Không tìm thấy thông tin phiên Admin để khôi phục');
    }

    const adminUser = backup.user;
    if (!adminUser.token && backup.token) {
      adminUser.token = backup.token;
    }

    await store.dispatch('setUser', adminUser);
    return { success: true, user: adminUser };
  }
};



// WEBPACK FOOTER //
// ./src/services/ImpersonateService.js